import React, { useState } from 'react';
import { Button } from '../common/Button';
interface BordereauRow {
  [key: string]: string;
}
interface UploadBordereauProps {
  onComplete: () => void;
}
export const UploadBordereau: React.FC<UploadBordereauProps> = ({
  onComplete
}) => {
  const [data, setData] = useState<BordereauRow[]>([]);
  const [fileName, setFileName] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isProcessing, setIsProcessing] = useState(false);
  const parseCsv = (text: string): BordereauRow[] => {
    const lines = text.split('\n').filter(line => line.trim());
    if (lines.length === 0) {
      throw new Error('CSV file is empty');
    }
    const headers = lines[0].split(',').map(h => h.trim());
    const rows = lines.slice(1).map(line => {
      const values = line.split(',').map(v => v.trim());
      const row: BordereauRow = {};
      headers.forEach((header, index) => {
        row[header] = values[index] || '';
      });
      return row;
    });
    return rows;
  };
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!file.name.endsWith('.csv')) {
      setError('Please upload a CSV file');
      return;
    }
    setIsProcessing(true);
    setFileName(file.name);
    const reader = new FileReader();
    reader.onload = e => {
      try {
        const text = e.target?.result as string;
        const rows = parseCsv(text);
        setData(rows);
        setError('');
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to parse CSV');
        setData([]);
      } finally {
        setIsProcessing(false);
      }
    };
    reader.onerror = () => {
      setError('Failed to read file');
      setIsProcessing(false);
    };
    reader.readAsText(file);
  };
  const handleSubmit = () => {
    if (data.length === 0) {
      setError('Please upload a valid CSV file first');
      return;
    }
    onComplete();
  };
  return <div className="max-w-3xl mx-auto" data-id="element-2570">
      <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-2571">
        Upload Bordereau
      </h2>
      <p className="text-gray-600 mb-6" data-id="element-2572">
        Upload your bordereau CSV file containing policy details
      </p>

      <div className="bg-white rounded-lg border-2 border-dashed border-gray-300 p-8 text-center mb-6 hover:border-blue-400 transition-colors" data-id="element-2573">
        <input type="file" accept=".csv" onChange={handleFileUpload} className="hidden" id="csv-upload" disabled={isProcessing} data-id="element-2574" />
        <label htmlFor="csv-upload" className="cursor-pointer flex flex-col items-center" data-id="element-2575">
          <svg className="w-12 h-12 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-2576">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" data-id="element-2577" />
          </svg>
          <span className="text-sm font-medium text-gray-700 mb-1" data-id="element-2578">
            {isProcessing ? 'Processing...' : 'Click to upload CSV'}
          </span>
          <span className="text-xs text-gray-500" data-id="element-2579">or drag and drop</span>
        </label>
      </div>

      {error && <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-md text-red-700 text-sm" data-id="element-2580">
          {error}
        </div>}

      {fileName && data.length > 0 && <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-md" data-id="element-2581">
          <div className="flex items-center text-green-700" data-id="element-2582">
            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" data-id="element-2583">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-2584" />
            </svg>
            <div data-id="element-2585">
              <p className="font-medium" data-id="element-2586">{fileName}</p>
              <p className="text-sm" data-id="element-2587">
                {data.length} rows imported successfully
              </p>
            </div>
          </div>
        </div>}

      <div className="flex justify-end gap-3" data-id="element-2588">
        <Button variant="primary" onClick={handleSubmit} disabled={data.length === 0 || isProcessing} data-id="element-2589">
          Continue
        </Button>
      </div>
    </div>;
};